// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1xMEW","inputs":"styles_inputs__1U_b6"};